var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3506 28.4211L16.3506 1.71289",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28605 16.186L15.4595 30.0152C15.571 30.1416 15.708 30.2429 15.8616 30.3122C16.0152 30.3815 16.1818 30.4174 16.3503 30.4174C16.5188 30.4174 16.6854 30.3815 16.839 30.3122C16.9926 30.2429 17.1297 30.1416 17.2412 30.0152L29.417 16.186",
    stroke: "#00842F",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.eb153349.svg";
export { ForwardRef as ReactComponent };